/* global performGoogleLogin, performFacebookLogin */

let currentSocialLoginData = null;

function clearErrors() {
  $('.social-consent-form__field .error').remove();
}

function showFieldError($field, message) {
  $field.closest('.social-consent-form__field').find('.error').remove();

  const $error = $('<div>', {
    class: 'error',
    html: message,
  });

  $field.closest('.social-consent-form__field').append($error);
}

function prefillFormFields(data) {
  $('#social-consent-email').val(data.email || '').trigger('change');
  $('#social-consent-name').val(data.firstName || '').trigger('change');
  $('#social-consent-surname').val(data.lastName || '').trigger('change');
}

function resetCheckboxes() {
  $('#social-consent-terms').prop('checked', false);
  $('#social-consent-newsletter').prop('checked', false);
}

/**
 * Show the social consent modal with user data
 * @param {Object} data - User data from social login
 * @param {string} data.provider - 'google' or 'facebook'
 * @param {string} data.email - User email
 * @param {string} data.firstName - User first name
 * @param {string} data.lastName - User last name
 * @param {Object} data.responsePayload - Full response from social provider
 */
window.showSocialConsentModal = function (data) {
  currentSocialLoginData = data;

  const $modalExplanation = $('#social-consent-modal-explanation');

  if ($modalExplanation.length) {
    const providerName = data.provider === 'google' ? 'Google' : 'Facebook';
    $modalExplanation.text(window.TRANSLATIONS.login.socialLoginConsentDescription.replace('{provider}', providerName));
  }

  prefillFormFields(data);
  resetCheckboxes();
  clearErrors();

  $('body').removeClass('cart-login-active');
  $('body').addClass('social-consent-modal-active');
};

function closeSocialConsentModal() {
  $('#social-consent-submit').removeClass('submitting');
  $('body').removeClass('social-consent-modal-active');
  currentSocialLoginData = null;
}

function validateSocialConsentForm() {
  clearErrors();

  const validationRules = [
    {
      field: $('#social-consent-name'),
      message: window.TRANSLATIONS.validation.requiredWithField,
      getValue: ($field) => $field.val().trim(),
      getLabel: ($field) => $field.parent().find('.material-label__label').text(),
    },
    {
      field: $('#social-consent-surname'),
      message: window.TRANSLATIONS.validation.requiredWithField,
      getValue: ($field) => $field.val().trim(),
      getLabel: ($field) => $field.parent().find('.material-label__label').text(),
    },
    {
      field: $('#social-consent-terms'),
      getValue: ($field) => $field.prop('checked'),
      message: window.TRANSLATIONS.validation.requiredAgreement,
    },
  ];

  const errors = {};
  validationRules.forEach((rule, index) => {
    const value = rule.getValue(rule.field);
    if (!value) {
      const label = rule.getLabel ? rule.getLabel(rule.field) : null;
      const errorMessage = label ? rule.message.replace('{field}', label) : rule.message;
      errors[index] = errorMessage;
      showFieldError(rule.field, errorMessage);
    }
  });

  const hasErrors = Object.keys(errors).length > 0;
  return !hasErrors;
}

async function handleSocialConsentSubmit(e) {
  e.preventDefault();

  if (!currentSocialLoginData || !validateSocialConsentForm()) {
    return;
  }

  const termsChecked = $('#social-consent-terms').prop('checked');
  const newsletterChecked = $('#social-consent-newsletter').prop('checked');
  const firstName = $('#social-consent-name').val().trim();
  const lastName = $('#social-consent-surname').val().trim();

  const $submitButton = $('#social-consent-submit');
  $submitButton.addClass('submitting');

  try {
    if (currentSocialLoginData.provider === 'google') {
      currentSocialLoginData.responsePayload.given_name = firstName;
      currentSocialLoginData.responsePayload.family_name = lastName;

      await performGoogleLogin(
        currentSocialLoginData.responsePayload,
        termsChecked,
        newsletterChecked,
      );

      closeSocialConsentModal();
    }

    if (currentSocialLoginData.provider === 'facebook') {
      currentSocialLoginData.responsePayload.first_name = firstName;
      currentSocialLoginData.responsePayload.last_name = lastName;

      await performFacebookLogin(
        currentSocialLoginData.responsePayload,
        termsChecked,
        newsletterChecked,
      );

      closeSocialConsentModal();
    }
  } catch (error) {
    $submitButton.removeClass('submitting');
  }
}

$(document).ready(() => {
  $('#social-consent-form').on('submit', handleSocialConsentSubmit);
  $(document).on('click', '[data-dialog-close="social-consent-modal"]', closeSocialConsentModal);
});
